import React, { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { nav, profile } from "../site";
import { EMAIL, MAILTO } from "./Email";

export default function Navbar() {
  const { pathname } = useLocation();
  const onDetail = pathname.startsWith("/portfolio");

  const [scrolled, setScrolled] = useState(false);
  const [hidden, setHidden] = useState(false);
  const [open, setOpen] = useState(false);
  const [current, setCurrent] = useState("");

  // Shadow after leaving the hero + hide-on-scroll-down.
  useEffect(() => {
    let last = window.scrollY;
    const onScroll = () => {
      const y = window.scrollY;
      setScrolled(y > 24);
      setHidden(!open && y > 320 && y > last);
      last = y;
    };
    window.addEventListener("scroll", onScroll, { passive: true });
    onScroll();
    return () => window.removeEventListener("scroll", onScroll);
  }, [open]);

  // Lock body scroll while the mobile drawer is open.
  useEffect(() => {
    document.body.classList.toggle("is-locked", open);
    return () => document.body.classList.remove("is-locked");
  }, [open]);

  // Close the drawer whenever the route changes.
  useEffect(() => {
    setOpen(false);
  }, [pathname]);

  // Highlight the section you're currently in (re-observes when the home page remounts).
  useEffect(() => {
    if (onDetail) return undefined;

    const ids = nav.map((item) => item.href.slice(1));
    const sections = ids.map((id) => document.getElementById(id)).filter(Boolean);
    if (!sections.length || typeof IntersectionObserver === "undefined") return undefined;

    const io = new IntersectionObserver(
      (entries) => {
        const visible = entries
          .filter((entry) => entry.isIntersecting)
          .sort((a, b) => b.intersectionRatio - a.intersectionRatio)[0];
        if (visible) setCurrent(visible.target.id);
      },
      { rootMargin: "-40% 0px -50% 0px", threshold: [0, 0.25, 0.5, 1] }
    );

    sections.forEach((section) => io.observe(section));
    return () => io.disconnect();
  }, [onDetail]);

  const active = onDetail ? "portfolio" : current;

  return (
    <header className={`nav${scrolled ? " is-scrolled" : ""}${hidden ? " is-hidden" : ""}${open ? " is-open" : ""}`}>
      <div className="shell nav__inner">
        <Link
          className="brand"
          to="/#home"
          onClick={(event) => {
            setOpen(false);
            if (!onDetail) {
              event.preventDefault();
              window.scrollTo({ top: 0, behavior: "smooth" });
            }
          }}
          aria-label={`${profile.name}, home`}
        >
          <span className="brand__text">{profile.name}</span>
        </Link>

        <nav className="nav__links" aria-label="Primary">
          {nav.map((item) => (
            <Link
              key={item.href}
              className={`nav__link${active === item.href.slice(1) ? " is-active" : ""}`}
              to={`/${item.href}`}
            >
              {item.label}
            </Link>
          ))}
        </nav>

        <button
          type="button"
          className="nav__burger"
          aria-label={open ? "Close menu" : "Open menu"}
          aria-expanded={open}
          aria-controls="mobile-nav"
          onClick={() => setOpen((value) => !value)}
        >
          <span />
          <span />
          <span />
        </button>
      </div>

      <div className="nav__drawer" id="mobile-nav">
        <div className="nav__drawerInner">
          <ul>
            {nav.map((item) => (
              <li key={item.href}>
                <Link to={`/${item.href}`} onClick={() => setOpen(false)}>
                  {item.label}
                </Link>
              </li>
            ))}
          </ul>

          <div className="nav__drawerFoot">
            <a className="nav__drawerEmail" href={MAILTO}>
              {EMAIL}
            </a>
          </div>
        </div>
      </div>
    </header>
  );
}
